export default "__VITE_ASSET__Cqr6MYAz__"